// @flow
// import isArray from './isArray';
// import isObject from './isObject';
import has from './has';

type ObjMap<T> = {
   [key: $Subtype<string>]: T
}

type Iterable<T> = Array<T> | ObjMap<T>
type Callback<T> = (T, number | string, Iterable<T>) => void

export default function each<T>(iterable: Iterable<T>, callback: Callback<T>) {
   if (iterable instanceof Array) {
      eachOfArray(iterable, callback);
   } else {
      eachOfObject(iterable, callback);
   }
}

function eachOfObject<T>(obj: ObjMap<T>, callback: Callback<T>) {
   // eslint-disable-next-line no-unused-vars
   for (const key in obj) {
      if (has(obj, key)) {
         callback(obj[key], key, obj);
      }
   }
}

function eachOfArray<T>(arr: T[], callback: Callback<T>) {
   for (let i = 0; i < arr.length; i++) {
      callback(arr[i], i, arr);
   }
}
